/* import __COLOCATED_TEMPLATE__ from './combo-box-header.hbs.js'; */
import { computed } from "@ember/object";
import { and, reads } from "@ember/object/computed";
import { classNames } from "@ember-decorators/component";
import SingleSelectHeaderComponent from "select-kit/components/select-kit/single-select-header";
const ComboBoxHeader = dt7948.c(class ComboBoxHeader extends SingleSelectHeaderComponent {
  static {
    dt7948.g(this.prototype, "clearable", [reads("selectKit.options.clearable")]);
  }
  #clearable = (dt7948.i(this, "clearable"), void 0);
  static {
    dt7948.g(this.prototype, "caretUpIcon", [reads("selectKit.options.caretUpIcon")]);
  }
  #caretUpIcon = (dt7948.i(this, "caretUpIcon"), void 0);
  static {
    dt7948.g(this.prototype, "caretDownIcon", [reads("selectKit.options.caretDownIcon")]);
  }
  #caretDownIcon = (dt7948.i(this, "caretDownIcon"), void 0);
  static {
    dt7948.g(this.prototype, "shouldDisplayClearableButton", [and("clearable", "value")]);
  }
  #shouldDisplayClearableButton = (dt7948.i(this, "shouldDisplayClearableButton"), void 0);
  get caretIcon() {
    return this.selectKit.isExpanded ? this.caretUpIcon : this.caretDownIcon;
  }
  static {
    dt7948.n(this.prototype, "caretIcon", [computed("selectKit.isExpanded", "caretUpIcon", "caretDownIcon")]);
  }
}, [classNames("combo-box-header")]);
export default ComboBoxHeader;